import React from 'react';
import { NormalizedProductReview, ProductReview } from '../../types';

import Reviews from '../../components/Reviews';

import StarRating from '../../components/StarRating';

const formatReviews = (reviews: ProductReview[]) =>
  reviews.map((review) => ({
    ...review,
    content: review.content.replace(/&#x27;/g, "'"),
    createdAt: new Date(review.createdAt).getTime(),
  }));

type Props = {
  onClickLoadMore: () => void;
  reviews: NormalizedProductReview;
  [key: string]: any;
};

const ProductReviews = (props: Props) => {
  const { onClickLoadMore } = props;
  const { data: reviews, totalReviewCount, averageStarRating } = props.reviews;

  if (reviews.length === 0) {
    return null;
  }

  return (
    <div {...props} id="product-reviews">
      <div className="container">
        <div className="row">
          <div className="col-span-12 sm:col-span-4">
            <div className="mb-32 space-y-16 bg-white p-32">
              <h2 className="text-h2-display">Customer Reviews</h2>

              <div className="space-y-4">
                <h4 className="text-h4">Overall</h4>

                <StarRating rating={averageStarRating} />

                <p className="text-sm">({totalReviewCount}&nbsp;reviews)</p>
              </div>
            </div>
          </div>

          <div className="col-span-12 sm:col-span-8">
            <Reviews
              reviews={formatReviews(reviews)}
              canLoadMore={reviews.length !== totalReviewCount}
              loadMoreClicked={onClickLoadMore}
              customFields={[
                { name: 'Fit', key: 'OVERALL FIT' },
                { name: 'Experience', key: 'EXPERIENCE' },
                { name: 'Quality', key: 'QUALITY' },
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductReviews;
